export default "__VITE_ASSET__pMBD2KU2__"